import React from "react"
import SignIn from "../../components/auth/SignIn"
// import './Home.scss'
const Home = ()=>{
    return <div className="home-container">
        <SignIn></SignIn>
    </div>
}

export default Home